import { css } from "styled-components";
import { BladeHeaderHeading } from "../../../../components/BladeHeaderHeading";
import { BladeHeaderBody } from "../../../../components/BladeHeaderBody";
import { BladeHeaderSupertitle } from "../../../../components/BladeHeaderSupertitle";
import { BladeHeaderTitle } from "../../../../components/BladeHeaderTitle";
import { textUppercaseMixin } from "../../../../../../skins/shared/mixins/typography";
import { BladeHeaderDecoration } from "../../../../components/BladeHeaderDecoration";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    position: relative;
    padding: 0 ${chroma.spacers.bladeEdge.right} ${chroma.spacers.bladeEdge.bottom};
    display: flex;
    flex-direction: row;
    padding-bottom: calc(${chroma.spacers.variable.m} * 1.5);

    ${chroma.mediaQueries.tabletDown} {
      flex-direction: column;
    }
  }

  ${BladeHeaderHeading},
  ${BladeHeaderBody} {
    flex: 1;
  }

  ${BladeHeaderSupertitle} {
    display: block;
    padding-bottom: ${chroma.spacers.variable.m};
    ${chroma.typography.eyebrow};
    color: ${paletteTokens.bladetext1};
  }

  ${BladeHeaderTitle} {
    display: block;
    ${chroma.mediaQueries.tabletDown} {
      overflow: hidden;
    }

    h2 {
      margin-right: ${chroma.spacers.variable.l};
      word-break: break-word;
      ${chroma.typography.display5};
      color: ${paletteTokens.bladetext1};

      ${chroma.mediaQueries.tabletDown} {
        padding-bottom: 20px;
        margin-right: 0;
      }
      ${textUppercaseMixin}
      ${chroma.mediaQueries.tabletDown} {
        float: left;
        position: relative;
        max-width: 100%;
      }
    }
  }

  ${BladeHeaderBody} {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    ${chroma.typography.body3};
    color: ${paletteTokens.bladetext1};

    ${chroma.mediaQueries.tabletDown} {
      justify-content: flex-start;
    }

    &:lang(ja-jp) {
      word-break: break-word;
    }
  }

  ${BladeHeaderDecoration} {
    display: none;
  }
`;
//# sourceMappingURL=index.js.map